import { ROLE_API_URL } from '@/services/constants';
import axiosClient from '../axiosClient';

const RoleServices = {
  fetchAllRoles: async ({ domainName, orgName, pageNumber, pageSize, roleName, appType, appName, permName, permType }: any) => {
    const response = await axiosClient.get(`${ROLE_API_URL}`, {
      params: {
        domainName: domainName,
        orgName: orgName,
        pageNumber: pageNumber,
        pageSize: pageSize,
        roleName: roleName,
        appType: appType,
        appName: appName,
        permName,
        permType
      }
    });
    return response.data;
  },
  createRole: async (body: any) => {
    try {
      const response = await axiosClient.post(`${ROLE_API_URL}`, body);
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  },
  updateRole: async (body: any, roleId: any) => {
    try {
      const response = await axiosClient.put(`${ROLE_API_URL}/${roleId}`, body);
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  },
  downloadRole: async () => {
    try {
      const response = await axiosClient.get(`${ROLE_API_URL}/download`);
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  },
  downloadCsv: async () => {
    try {
      const response = await axiosClient.get(`${ROLE_API_URL}/downloadsamplefile`);
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  },
  uploadCsv: async (params: any) => {
    try {
      const response = await axiosClient.post(`${ROLE_API_URL}/UploadCsv`, params?.data, {
        headers: {
          'Content-Type': 'application/JSON'
        },
        params: {
          dom_name: params?.dom_name,
          org_name:params?.org_name,
          app_name:params?.app_name,
          app_type:params?.app_type,
          role_type:params?.role_type,
          created_by: params?.created_by,
          modified_by: params?.modified_by,
          status: params?.status
        }
      });
      return response.data;
    } catch (error: any) {
      return error?.response?.data;
    }
  },
  deleteRoles: async (params: any) => {
    try {
      const response = await axiosClient.delete(`${ROLE_API_URL}`, {
        params
      });
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  },
  deleteBulkRoles: async (params: any) => {
    try {
      const response = await axiosClient.delete(`${ROLE_API_URL}/bulk`, {
        params
      });
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  }
};

export default RoleServices;
